import { AxiosResponse } from "axios";
import { api } from ".";
import { INormalisedRelations, MediaAssetFields, RelationshipsResponse } from "../types";

export interface IV2MediaItem extends MediaAssetFields {
  id: number;
  name: string;
  description: string;
  thumbnail: string;
  media_type: string;
  created_at: string;
  last_updated_at: string;
  relationships?: RelationshipsResponse;
  relations?: INormalisedRelations;
}

/**
 * Permanently deletes a media item via the v2 API.
 * Endpoint: DELETE /api/v2/media/{id}/
 */
export const deleteV2MediaItem = async (id: string | number): Promise<void> => {
  await api.delete(`v2/media/${id}/`);
};

/**
 * Updates a media item's name/description via the v2 API.
 * Endpoint: PATCH /api/v2/media/{id}/
 */
export const updateV2MediaItem = async (
  id: string | number,
  data: { name?: string; description?: string; restrictions?: number[] }
): Promise<AxiosResponse<IV2MediaItem>> => {
  return api.patch(`v2/media/${id}/`, data);
};

/** An embed to create: a third-party viewer (YouTube, Sketchfab, Polycam…), not an uploaded file. */
export interface V2EmbedCreate {
  name: string;
  description: string;
  /** `embed/video` or `embed/3d`. */
  media_type: string;
  /** The iframe src. */
  embed_url: string;
  thumbnail?: string | null;
}

/**
 * Creates an embed via the v2 API, with its URL at the top level (not in the
 * deprecated `remote_details`).
 * Endpoint: POST /api/v2/media/
 */
export const createV2Embed = async (embed: V2EmbedCreate): Promise<IV2MediaItem> => {
  const res = await api.post("v2/media/", embed);
  return res.data;
};
